export type GraphAxisData = {
    x: Array<{value: number; label: string}>;
    y: Array<{value: number; label: string}>;
};
export type GraphValues = Array<{x: number; y: number}>;

export const axisDataFromGraphValues = (
    graphValues: GraphValues,
    formatX: (value: number) => string,
    formatY: (value: number) => string,
): GraphAxisData => {
    const maxSpeedBuffer: number = 0.2; // Should be replaced with a relative value, but works for now.

    // Calculate the value ranges.
    const xValues = graphValues.map((d) => d.x);
    const yValues = graphValues.map((d) => d.y);
    const xMin = Math.min.apply(0, xValues);
    const xMax = Math.max.apply(0, xValues);
    const yMin = Math.min.apply(0, yValues);
    const yMax = Math.max.apply(0, yValues) + maxSpeedBuffer;
    const xStep = (xMax - xMin) / 7;

    // Create a list of values and labels that fit the graph.
    const axisData: GraphAxisData = {x: [], y: []};
    for (let index = 0; index < 8; index++) {
        const xValue: number = xMin + xStep * index;
        const yValue: number = yMin + (yMax - yMin) * (1 - index / 8);
        axisData.x.push({value: xValue, label: index % 7 === 0 ? '' : formatX(xValue)});
        axisData.y.push({value: (8 - index) / 8, label: index % 2 === 0 ? '' : formatY(yValue)});
    }
    return axisData;
};
